module.exports = __webpack_public_path__ + "static/img/tjsp2.566a10b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/tjsp2.png
// module id = 1276
// module chunks = 0